import React from 'react'

export default class DropdownGender extends React.Component
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option
	
	static get defaultProps() 
	{
		var v = 
	    {
		      mode: 'list', 
	    	  label: 'Select a Gender' , 
	    	  defaultGender: '#' 
		}

		return v;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

    	// Create a state item here
		this.state = { currentGender: this.props.defaultGender, items: null };
		
	}

	UNSAFE_componentWillMount()
	{		
		// This is a callback to tell the parent our ID so it can talk to this contrao
		if ( this.props.parentRef != null )
		{
			this.props.parentRef ( this.props.id, this ) ;		
		}
		
		// Fetch the list of types to populste the dropdown
		this.getdata () ;
	}
	
	getdata( )
	{
		var sexes = [
		{
			id: '#',
			desc: 'Please select a gender'
		},			  
		{
			id: 'M',
			desc: 'Male'
		},
		{
			id: 'F',
			desc: 'Female'
		},
		];
				
		this.setState ( { items : sexes } ) ;
	}
	
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0 || param == -1 || param == '#')
				{
					if ( this.state.items == null )
					{
						return true ;
					}
					else
					{
						if ( this.state.items.length > 0)
						{
							return false ;						
						}
						else
						{
							return true ;
						}
					}
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}
	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	isValid()
	{		
		return this.isValueValid ( this.getValue() ) ;
	}
	
	handleChange(e) 
	{
		var targetName = e.target.name ;
		var val = e.target.value ;
		var index = e.target.selectedIndex;

		// Need to calculate the offset to read the actual Type Id from the correct place in the table
		// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for
		
		var offset = 0 ;
		
		if ( this.props.mode == 'filter')
		{
			var offset = -1 ;
		}

		if ( index >= 0 )
		{
			var itemid = this.state.items[index+offset].id;			
			var itemtext = this.state.items[index+offset].desc ;
			
			this.setState ( {currentGender: itemid} ) ;
		}
		else
		{
			var itemid = 0 ;		
			var itemtext = "All" ;				

			this.setState ( {currentGender: itemid} ) ;
		}
		
		// Tell the owning function about the change	
		
		if ( this.props.callback != null )
		{
			this.props.callback ( itemtext ) ;		
		}
		
	}
	  
    getValue()
    {
    	return this.state.currentGender ;
    }
    
    optionList ()
    {
        var lineList=[];
        
        // This element renders from the list of user types returned by the getdata() ajax function above
    	var itemArray = this.state.items ;

    	if ( itemArray != null )
        {
        	var i = 0 ;
            var len = itemArray.length;
            var row = null ;
            var typeId = null ;
            var typeText = null ;
            
            // If it's a filter list, add the 'ALL' option
                		
            for (i=0; i<len; ++i) 
            {
            	if (i in itemArray) 
            	{
            		row = itemArray[i];
            		
            		typeId = row.id ;
            		typeText = row.desc;
            		
            		lineList.push(React.createElement ( 'option', {key: this.keyCount++, name: typeId, value: typeId} , typeText));        			
            	}
            }
        }
        
        return lineList ;
    }
    
    dropdown_select ( id )
    {
    	return React.createElement ( 'select', {key: this.keyCount++, value: this.state.currentGender, className: 'form-control', id: id , tabIndex: this.props.tabIndex, onChange: this.handleChange.bind(this)}, this.optionList() ) ;
    }
    
    
    /**
     * Generates HTML for the error DIV which wil be visible if the field contents are
     * invalid AND the this.props.displayErrors flag is set. This will generally be set 
     * by the parent form if error display is required.
     * 
     * @param {bool} validFlag - True if this field is currnetly invalid.
     * @return {void} 
     */
	errorDiv ( validFlag )
	{
		var errmsg = "&nbsp;";
		
		if ( this.props.errorText != null )
		{
			if ( this.props.errorText.length != 0)
			{
				errmsg = this.props.errorText ;
			}
		}

		var className = 'input-error-invisible' ;
		
		if ( this.props.displayErrors == true && this.isValid() != true )
		{
			className = 'input-error-visible' ;
		}
		
		return React.createElement ('div', {  htmlFor: this.props.id, key: this.keyCount++, className: className} , errmsg ) ;		
	}
	
    optionDropdown(id)
    {
    	var lineList=[];
    	
        lineList.push (React.createElement('label', {  key: this.keyCount++, htmlFor: this.props.id, className: 'col-form-label'}, this.props.label ));
    	lineList.push( this.dropdown_select(id));
    	
        if ( this.props.displayErrors == true )
    	{
            lineList.push ( this.errorDiv(true) ) ;    	
    	}
    	
    	
    	return lineList ;
    }
  
    render() 
    {
        return React.createElement ( 'div', {key: this.keyCount++, className: 'input-group'}, this.optionDropdown('list1')) ;				
    }
};


